import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { useAuth } from "./authContext";
import { firebaseConfig, app, auth as firebaseAuthInstance } from "./firebase";

// Initialize compat version for FirebaseUI
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const FirebaseAuth = () => {
  const uiRef = useRef(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Wait until authentication state is determined
    if (loading) {
      return;
    }

    // If user is already logged in, don't initialize FirebaseUI
    if (user) {
      return;
    }
    
    // Only initialize Firebase UI if user is not logged in
    const auth = firebase.auth();
    
    // Initialize and render the FirebaseUI widget
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
    
    uiRef.current && ui.start(uiRef.current, {
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],

      signInFlow: "popup",
      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          localStorage.setItem('userAuthenticated', 'true');
          localStorage.setItem('userAuthTime', new Date().toISOString());
          localStorage.setItem('userEmail', authResult.user.email || 'unknown');
          localStorage.setItem('userUid', authResult.user.uid || 'unknown');
          
          navigate('/');
          
          return false;
        },
        signInFailure: (error) => {
          setError("Authentication failed: " + error.message);
        }
      }
    });
    
    // Cleanup function
    return () => {
      ui.reset();
    };
  }, [navigate, user, loading]);

  return (
    <div className="auth-container">
      {error && <div className="auth-error">{error}</div>}
      <div 
        ref={uiRef} 
        className="firebaseui-container"
      />
    </div>
  );
};

export default FirebaseAuth;
